import clsx from "clsx";
import "./SectionTitle.css";

interface SectionTitleProps {
  Icon: React.ElementType;
  title: string;
  className?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  Icon,
  title,
  className,
}) => {
  return (
    <div className={clsx("section-title", className)}>
      <Icon className="inline" />
      <span>{title}</span>
    </div>
  );
};

export default SectionTitle;
